module.exports = __webpack_public_path__ + "img/money-envelope.c055d483.svg";